<app-page-section sectionClass="section-pad" containerClass="container">
  <div class="row justify-content-center">
    <div class="col-lg-7 col-xl-6">
      <div class="soft-card bg-white p-4 p-md-5">
        <div class="mb-4">
          <span class="badge rounded-pill text-bg-primary mb-3">{{ i18n.t('forgotPassword.badge') }}</span>
          <h1 class="fw-bold mb-2">{{ i18n.t('forgotPassword.title') }}</h1>
          <p class="lead text-secondary mb-0">{{ i18n.t('forgotPassword.subtitle') }}</p>
        </div>

        <form class="row g-3" (ngSubmit)="requestReset()">
          <div class="col-12"><p class="required-fields-notice text-secondary small bg-light rounded-3 p-3 mb-0">{{ i18n.t('common.requiredFieldsNotice') }}</p></div>
          <div class="col-12">
            <label class="form-label" for="forgotPasswordEmail">{{ i18n.t('common.email') }}<span class="required-star" aria-hidden="true">*</span></label>
            <input id="forgotPasswordEmail" class="form-control form-control-lg" type="email" name="email" [(ngModel)]="email" autocomplete="email" [disabled]="isRequestingReset || isConfirmingReset" required>
          </div>

          @if (status === 'invalid') { <div class="col-12"><div class="alert alert-warning mb-0">{{ i18n.t('forgotPassword.validationError') }}</div></div> }
          @if (status === 'codeSent') { <div class="col-12"><div class="alert alert-info mb-0">{{ i18n.t('forgotPassword.codeSent') }}</div></div> }
          @if (status === 'requestFailed') { <div class="col-12"><div class="alert alert-danger mb-0">{{ i18n.t('forgotPassword.requestFailed') }}</div></div> }

          <div class="col-12">
            <button class="btn btn-outline-primary btn-lg w-100" type="submit" [disabled]="isRequestingReset || isConfirmingReset" [attr.aria-busy]="isRequestingReset">
              @if (isRequestingReset) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
              <span>{{ isRequestingReset ? i18n.t('forgotPassword.requestingReset') : i18n.t('forgotPassword.requestReset') }}</span>
            </button>
          </div>
        </form>

        <form class="row g-3 mt-3" (ngSubmit)="confirmReset()">
          <div class="col-12"><p class="required-fields-notice text-secondary small bg-light rounded-3 p-3 mb-0">{{ i18n.t('common.requiredFieldsNotice') }}</p></div>
          <div class="col-12">
            <label class="form-label" for="forgotPasswordCode">{{ i18n.t('forgotPassword.resetCode') }}<span class="required-star" aria-hidden="true">*</span></label>
            <input id="forgotPasswordCode" class="form-control form-control-lg" name="resetCode" [(ngModel)]="resetCode" autocomplete="one-time-code" [disabled]="isConfirmingReset" required>
          </div>
          <div class="col-12">
            <label class="form-label" for="forgotPasswordNewPassword">{{ i18n.t('forgotPassword.newPassword') }}<span class="required-star" aria-hidden="true">*</span></label>
            <input id="forgotPasswordNewPassword" class="form-control form-control-lg" type="password" name="newPassword" [(ngModel)]="newPassword" autocomplete="new-password" [disabled]="isConfirmingReset" required>
          </div>

          @if (status === 'confirmed') { <div class="col-12"><div class="alert alert-success mb-0">{{ i18n.t('forgotPassword.confirmed') }}</div></div> }
          @if (status === 'weakPassword') { <div class="col-12"><div class="alert alert-warning mb-0">{{ i18n.t('forgotPassword.passwordPolicy') }}</div></div> }
          @if (status === 'confirmFailed') { <div class="col-12"><div class="alert alert-danger mb-0">{{ i18n.t('forgotPassword.confirmFailed') }}</div></div> }

          <div class="col-12">
            <button class="btn btn-primary btn-lg w-100" type="submit" [disabled]="isConfirmingReset" [attr.aria-busy]="isConfirmingReset">
              @if (isConfirmingReset) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
              <span>{{ isConfirmingReset ? i18n.t('forgotPassword.confirmingReset') : i18n.t('forgotPassword.confirmReset') }}</span>
            </button>
          </div>
        </form>

        <p class="small text-secondary mt-4 mb-0">{{ i18n.t('forgotPassword.rememberedPassword') }} <a routerLink="/login">{{ i18n.t('forgotPassword.signIn') }}</a></p>
      </div>
    </div>
  </div>
</app-page-section>